import { env } from 'process';
import { environment } from '../environments/environment';

export class Apis {
  static me = `${environment.base_url}/user/getProfile`;
  static adminLogin = `${environment.base_url}/login/email`;
  static getApplicationToLoginWith = `${environment.base_url}/application/getApplicationToLoginWith`;

  static refreshToken = `${environment.base_url}/refreshToken`;

  static byCategory = `${environment.base_url}/accessControl/byCategory`;
  static accessControl = `${environment.base_url}/accessControl`;

  static changePassword = `${environment.base_url}/password/changePassword`;
  static forgotPassword = `${environment.base_url}/password/forgotPassword`;
  static passwordConditions = `${environment.base_url}/password/conditions`;
  static checkfrequencyUnit = `${environment.base_url}/enums/CheckFrequencyUnit`;
  static stopfrequencyafterUnit = `${environment.base_url}/enums/stopCheckAfterUnit`;
  static status = `${environment.base_url}/enums/status`;
  static result = `${environment.base_url}/enums/result`;
  static sendOTP = `${environment.base_url}/password/forgotPassword/sendOtp`;
  static otpDeliveryChannel = `${environment.base_url}/enums/otpDeliveryChannel`;
  static otpDigits = `${environment.base_url}/otp/getOtpDigitsCount`;
  static getApplicationApiKeys = `${environment.base_url}/user/getApiKeys`;
  static createApplicationApiKeys = `${environment.base_url}/user/createApiKey`;
  static deActivateApplicationApiKeys = `${environment.base_url}/user/deActivateApiKey`;

  static createApiKeyForAdmin = `${environment.base_url}/user/application/createApiKey `;
  static deactivateApiKeysForAdmin = `${environment.base_url}/user/application/deActivateApiKey `;

  static getMasterUserList = `${environment.base_url}/getUsers`;

  static createMasterUser = `${environment.base_url}/user/createUser`;
  static updateMasterUser = `${environment.base_url}/user/updateSanctionCheckParams`;
  static getAdminUserList = `${environment.base_url}/masterUser/getAdmins`;
  static createAdminUser = `${environment.base_url}/masterUser/createAdminUser`;
  static acceptUser = `${environment.base_url}/user/approve`;
  static rejectUser = `${environment.base_url}/user/reject`;

  static countryList = `${environment.base_url}/countries`;

  static getMasterApplicationList = `${environment.base_url}/application/getApplications`;
  static getApplicationListById = `${environment.base_url}/application/getApplicationById`;
  static createMasterApplication = `${environment.base_url}/application`;
  static createVerificationTier = `${environment.base_url}/verificationTier`;
  static createDocumentCategory = `${environment.base_url}/documentCategory/addDocumentCategory`;

  static getMasterApplicationGroupList = `${environment.base_url}/getAllApplicationGroups`;
  static createMasterApplicationGroup = `${environment.base_url}/applicationGroup`;

  static linkApplicationGroups = `${environment.base_url}/linkApplicationGroups`;

  static getUserLogList = `${environment.base_url}/user/getLogs`;
  static dateRangeType = `${environment.base_url}/enums/dateRangeType`;
  static getApiForUserLogs = `${environment.base_url}/user/getAllApi`;

  static sendMail = `${environment.base_url}/trustedDevice/sendVerificationMailAgain`;
  static getResendOtpDelaySeconds = `${environment.base_url}/otp/getResendOtpDelaySeconds`;

  static getSubUserList = `${environment.base_url}/getSubUsers`;
  static createSubUser = `${environment.base_url}/user/createSubUser`;

  static getAllSanction = `${environment.base_url}/sanction/getAllSanctions`;
  static getAllSanctionDetail = `${environment.base_url}/sanction/getSanctionDetails`;

  static getCustomer = `${environment.base_url}/user/getCustomers`;
  static getPustomerPopulate = `${environment.base_url}/sanction/getPrefillDataForCustomerSignUp`;
  static createCustomer = `${environment.base_url}/user/createCustomer`;
  static getCustomerDetailsById = `${environment.base_url}/user/getCustomerDetails`;
  static getSanctionByCustomerId = `${environment.base_url}/user/getSanctionByCustomerId`;
  static getSanctionReportForGroupIdAndCustomerId = `${environment.base_url}/sanction/getSanctionReportForGroupIdAndCustomerId`;
  static getSanctionReport = `${environment.base_url}/sanction/getSanctionReport`;
  static getSanctionDetailsById = `${environment.base_url}/sanction/getSanctionDetails`;
  static updateRepeatCheckParam = `${environment.base_url}/user/updateRepeatCheckParam`;

  static getAccessRole = `${environment.base_url}/user/accessRole`;
  static addAccessRole = `${environment.base_url}/user/accessRole/add`;
  static deleteAccessControlPolicy = `${environment.base_url}/user/accessControlPolicy/delete`;
  static getAccessControlByAccessRoleId = `${environment.base_url}/accessControl/forAccessRole`;
  static addAccessControlPolicy = `${environment.base_url}/user/accessControlPolicy/add`;
  static getAccessRoleByAccessRoleId = `${environment.base_url}/user/accessRole/byId`;
  static updateColumnsForAccessRole = `${environment.base_url}/user/accessRole/updateFilterColumns`;
  static getEntityNames = `${environment.base_url}/entity`;
  static getClassStructureForEntity = `${environment.base_url}/entity/getClassStructure`;

  static getAllNotificationConfig = `${environment.base_url}/notificationConfig/getAllConfigs`;
  static updateNotificationConfig = `${environment.base_url}/notificationConfig/update`;
  static notificationBannerType = `${environment.base_url}/enums/notificationBannerType`;
  static notificationBannerDestination = `${environment.base_url}/enums/notificationBannerDestination`;
  static getConfigById = `${environment.base_url}/notificationConfig/getById`;

  static getDirectBillingList = `${environment.base_url}/user/billing/getBillings`;
  static createDirectBilling = `${environment.base_url}/user/billing`;
  static getChildrenBillingList = `${environment.base_url}/user/billing/getGrandBillings`;
  static createChildrenBilling = `${environment.base_url}/user/billing/children`;
  static getBillingLog = `${environment.base_url}/user/billing/getLog`;
  static getGrandBillingLog = `${environment.base_url}/user/billing/getGrandLog`;

  static getDocumentList = `${environment.base_url}/documents/getAllDocument`;
  static documentUploadByUrl = `${environment.base_url}/documents/documentUploadUrl`;
  static getApplicableDocumentCategory = `${environment.base_url}/documentCategory/getApplicableDocumentCategory`;

  static getPublicUrlByDocumentId = `${environment.base_url}/documents/getPublicUrl`;
  static getDocumentApproveByDocumentId = `${environment.base_url}/documents/approve`;
  static getDocumentRejectByDocumentId = `${environment.base_url}/documents/reject`;

  static getSanctionList = `${environment.base_url}/sanction/allSources`;
  static getSanctionListById = `${environment.base_url}/sanction/getSource`;
  static updateSanctionById = `${environment.base_url}/sanction/updateSourceById`;
  static getScheduleType = `${environment.base_url}/enums/scheduleType`;
  static getTimeUnit = `${environment.base_url}/enums/timeUnit`;

  static userType = `${environment.base_url}/enums/userType`;
  static getBillingType = `${environment.base_url}/enums/billingType`;
  static getBillingStatus = `${environment.base_url}/enums/billingStatus`;
  static getVerificationTierLevel = `${environment.base_url}/enums/verificationTierLevel`;
  static getVerificationExpiryTime = `${environment.base_url}/enums/timeUnit`;
  static getDocumentExpiry = `${environment.base_url}/enums/documentExpiryAction`;
  static getDocumentStatus = `${environment.base_url}/enums/documentStatus`;

  static twoFactorInit = `${environment.base_url}/twoFactor/init`;
  static validateTwoFactorOTP = `${environment.base_url}/twoFactor/validateTwoFactorOTP`;
  static setUpTwoFactor = `${environment.base_url}/twoFactor/setUpTOtp`;
  static isTOTPSetUpDone = `${environment.base_url}/twoFactor/isTOTPSetUpDone`;
  static initiateSetupTwoFactor = `${environment.base_url}/twoFactor/initiateSetupTwoFactor`;

  static blockJwtToken = `${environment.base_url}/blockJwtToken`;

  static scanSanction = `${environment.base_url}/sanction/scan`;
  static checkParamType = `${environment.base_url}/enums/checkParamType`;
  static checkFrequencyUnit = `${environment.base_url}/enums/checkFrequencyUnit`;
  static flaggedConsequence = `${environment.base_url}/enums/flaggedConsequence`;
  static getPrefillDataForCustomerSignUp = `${environment.base_url}/sanction/getPrefillDataForCustomerSignUp`;

  static getBatchList = `${environment.base_url}/sanction/batchList`;
  static getStatusForBatch = `${environment.base_url}/enums/status`;

  static sharableLink = `${environment.base_url}/createSanctionShareableLink`;
}
